import { render, staticRenderFns } from "./DescriptionItem.vue?vue&type=template&id=667d1590&scoped=true&"
import script from "./DescriptionItem.vue?vue&type=script&lang=js&"
export * from "./DescriptionItem.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionItem.vue?vue&type=style&index=0&id=667d1590&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667d1590",
  null
  
)

export default component.exports